import { FC, useState, useEffect } from 'react';
import { Container } from '@mui/material';
import BraintreeDropinContainer from './braintree-dropin-container';
import { PayNowClient } from '@acorn-portal/shared/src/services/api';
import API from '@acorn-portal/shared/src/services/AxiosInstance';

interface IProps {
	amount: string;
	isOptOut: boolean;
	cardOnly?: boolean;
	noPayPal?: boolean;
	noMobileWallets?: boolean;
	setError?: (error: string) => void;
}

const BraintreeFormInput: FC<IProps> = ({
	amount,
	isOptOut,
	cardOnly,
	noPayPal,
	noMobileWallets,
	setError = () => {},
}) => {
	const [clientToken, setClientToken] = useState<string | undefined>(undefined);

	useEffect(() => {
		let isMounted = true;
		const loadClientToken = async () => {
			try {
				const service = new PayNowClient(undefined, API);
				const token = await service.generatePaymentToken(import.meta.env.VITE_MERCHANT);
				if (isMounted) {
					setClientToken(token);
				}
			} catch (error) {
				console.error('Error fetching client token:', error);
				if (isMounted) {
					setError('Failed to fetch client token');
				}
			}
		};

		loadClientToken();

		return () => {
			isMounted = false;
		};
	}, []);

	return (
		<Container maxWidth='sm' sx={{ px: 0 }}>
			<BraintreeDropinContainer
				clientToken={clientToken ?? ''}
				amount={amount}
				isOptOut={isOptOut}
				cardOnly={cardOnly}
				noPayPal={noPayPal}
				noMobileWallets={noMobileWallets}
			/>
		</Container>
	);
};

export default BraintreeFormInput;
